import {Box} from "@mui/material";

import {mirage} from "ldrs";
mirage.register();

export default function PageLoading() {
	return (
		<Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" sx={{height: "100%"}}>
			<l-mirage size="120" color={"#42a5f5"}></l-mirage>
		</Box>
	)
}
